export default __webpack_public_path__ + "static/media/coin.05106715.png";